import Button
    from "./Button";

const GreenButton = ({extraClasses = '', children, ...rest}) => {
    return (
        <Button extraClasses={`btn flex items-center transition disabled:bg-slate-100 disabled:text-slate-900 bg-[#23a455] text-white hover:bg-[#1e8a47] hover:text-white disabled:bg-[rgba(35,164,85,0.36)] ${extraClasses}`} {...rest}>
            {children}
        </Button>
    );
}

export default GreenButton;
export { GreenButton }
